import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import userService from "../../../../api/Authentication/AuthenticationService";
export default class CreateUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        en_fullname: null,
        ar_fullname: null,
        email: null,
        company: null,
        dept: null,
        id_no: null,
        password: null,
        status: null,
        role: null,
      },
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {}

  onChange = (e) => {
    let user = this.state.user;
    user[e.target.name] = e.target.value;
    this.setState({ user });
  };

  onSelect = (name, e) => {
    let user = this.state.user;
    user[name] = e.target.value;
    this.setState({ user });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  saveUser = () => {
    userService.registerUser({
      en_fullname: this.state.user.en_fullname,
      ar_fullname: this.state.user.ar_fullname,
      email: this.state.user.email,
      company: this.state.user.company,
      dept: this.state.user.dept,
      id_no: this.state.user.id_no,
      password: this.state.user.password,
      status: this.state.user.status,
      role: this.state.user.role,
    });
    document.getElementById("en_fullname").value = "";
    document.getElementById("ar_fullname").value = "";
    document.getElementById("password").value = "";
    document.getElementById("email").value = "";
    document.getElementById("dept").value = "";
    document.getElementById("id_no").value = "";
    document.getElementById("company").value = "";
    document.getElementById("role").selectedIndex = 0;
    document.getElementById("status").selectedIndex = 0;
    toast.success(`User Created Successfuly`, {
      position: toast.POSITION.TOP_CENTER,
    });
  };

  render() {
    return (
      <>
        <h5 className="m-0">Create User</h5>
        <Row form className="mt-4">
          <Col md="6" className="form-group">
            <FormGroup controlId="email" id="create-user">
              <label>English Name</label>
              <FormControl
                autoFocus
                type="text"
                name="en_fullname"
                id="en_fullname"
                onChange={this.onChange}
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup controlId="password" id="create-user">
              <label>Arabic Name</label>
              <FormControl
                onChange={this.onChange}
                type="text"
                name="ar_fullname"
                id="ar_fullname"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md="6">
            <FormGroup controlId="password" id="create-user">
              <label>Email</label>
              <FormControl
                onChange={this.onChange}
                type="email"
                name="email"
                id="email"
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup controlId="password" id="create-user">
              <label>Password</label>
              <FormControl
                onChange={this.onChange}
                type="password"
                name="password"
                id="password"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md="6">
            <FormGroup controlId="password" id="create-user">
              <label>Company</label>
              <FormControl
                onChange={this.onChange}
                type="text"
                name="company"
                id="company"
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup controlId="password" id="create-user">
              <label>Department</label>
              <FormControl
                onChange={this.onChange}
                type="text"
                name="dept"
                id="dept"
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup controlId="password" id="create-user">
              <label>ID Number</label>
              <FormControl
                onChange={this.onChange}
                type="text"
                name="id_no"
                id="id_no"
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group pt-2 align-self-top">
            <div class="form-group" id="role">
              <label for="role">Role</label>
              <select
                class="form-control"
                id="role"
                name="role"
                onChange={(e) => this.onSelect("role", e)}
              >
                <option value="#">Select Role</option>
                <option value="admin">Admin</option>
                <option value="moderator">Moderator</option>
                <option value="Employee">Employee</option>
              </select>
            </div>
          </Col>
          <Col md="6" className="form-group pt-2 align-self-top">
            <div class="form-group" id="role">
              <label for="role">Status</label>
              <select
                class="form-control"
                id="status"
                name="status"
                onChange={(e) => this.onSelect("status", e)}
              >
                <option value="#">Select Status</option>
                <option value="active">Active</option>
                <option value="disable">Disable</option>
              </select>
            </div>
          </Col>
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={this.saveUser}
            >
              Create
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
